import { tokens } from '@equinor/eds-tokens';

var logoFillPositive = tokens.colors.logo.fill_positive.rgba;
var token = {
  background: logoFillPositive
};

export { token };
